<template>
  <div class="modal sign-modal">
    <div class="overlay" @click="$parent.closeSignInModal"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$parent.closeSignInModal"
        src="./../images/close.svg"
      />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">{{ $t(`Welcome back`) }}</div>

                <div v-if="$parent.accountLocked" class="locked-account-popup">
                  <div class="lock-icon">🔒</div>
                  <div class="lock-title">{{ $t("Account Locked") }}</div>
                  <div class="lock-message">
                    {{
                      $t(
                        "Sorry, your account was disabled due to many incorrect password attempts. Please, contact our support:"
                      )
                    }}
                  </div>
                  <a
                    :href="'mailto:' + $parent.companyEmail"
                    class="support-email-link"
                    >{{ $parent.companyEmail }}</a
                  >
                </div>

                <div v-if="!$parent.accountLocked">
                  <label>
                    <input
                      :placeholder="$t(`E-mail address:`) + ` *`"
                      type="email"
                      v-model="email"
                    />
                  </label>
                  <label>
                    <input
                      :placeholder="$t(`Password:`) + ` *`"
                      type="password"
                      v-model="pass"
                    />
                  </label>
                  <div class="link-container">
                    <div class="desc link" @click="$parent.openRecover">
                      {{ $t(`Forgot password?`) }}
                    </div>
                  </div>
                  <button class="button" @click="submitLogin">
                    <span>{{ $t(`Login`) }}</span>
                  </button>
                  <div class="desc link" @click="$parent.openRegister">
                    {{ $t(`Sign Up!`) }}
                  </div>

                  <div v-if="$parent.error" class="desc red">
                    {{ $parent.error }}
                  </div>

                  <div
                    v-if="$parent.loginAttempts > 0"
                    class="login-attempts-counter"
                  >
                    {{ $parent.loginAttempts }}/{{ $parent.maxAttempts || 5 }}
                    {{ $t("incorrect password try's") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignInModal",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      pass: "",
    };
  },
  computed: {},
  methods: {
    submitLogin() {
      let loginData = {
        username: this.email,
        password: this.pass,
      };
      this.$emit("login", loginData);
    },
  },
};
</script>

<style scoped>
.sign-modal {
  line-height: 1;
}

.login-attempts-counter {
  color: #ff9800;
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
  font-weight: normal;
}

.red {
  color: #f44336;
  font-size: 12px;
  margin-top: 8px;
  text-align: center;
}

.locked-account-popup {
  background-color: #ffebee;
  border: 1px solid #f44336;
  border-radius: 8px;
  padding: 24px 20px;
  margin: 12px auto 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  transition: all 0.3s ease;
}

.lock-icon {
  font-size: 36px;
  margin-bottom: 16px;
}

.lock-title {
  font-size: 20px;
  font-weight: bold;
  color: #f44336;
  margin-bottom: 12px;
  width: 100%;
}

.lock-message {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
  width: 100%;
}

.support-email-link {
  color: #f44336;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
  border-radius: 4px;
  display: inline-block;
  word-break: break-all;
  max-width: 100%;
  transition: all 0.2s ease;
}

.support-email-link:hover {
  background-color: #f44336;
  color: white;
  opacity: 1;
}

@media (max-width: 640px) {
  .locked-account-popup {
    padding: 16px 12px;
    border-radius: 6px;
    margin: 10px auto 16px;
  }

  .lock-icon {
    font-size: 28px;
    margin-bottom: 10px;
  }

  .lock-title {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .lock-message {
    font-size: 13px;
    line-height: 1.4;
    margin-bottom: 16px;
  }

  .support-email-link {
    font-size: 14px;
    padding: 6px 12px;
  }
}

@media (max-width: 480px) {
  .locked-account-popup {
    padding: 14px 10px;
  }

  .lock-message {
    font-size: 12px;
  }

  .support-email-link {
    padding: 5px 10px;
    font-size: 13px;
  }
}

.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
